import { render, staticRenderFns } from "./Transition1point5.vue?vue&type=template&id=57a9a20a&scoped=true"
import script from "./Transition1point5.vue?vue&type=script&lang=js"
export * from "./Transition1point5.vue?vue&type=script&lang=js"
import style0 from "./Transition1point5.vue?vue&type=style&index=0&id=57a9a20a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a9a20a",
  null
  
)

export default component.exports